import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";

export default class GbResidueInput extends React.Component {
  fetchData = (search) =>
    fetchJson("/mrls/gb_residues.json", { search }).then((records) =>
      records.map((m) => ({ label: m.name, value: m.id }))
    );

  customStyles = () => {
    const { width, defaultStyle } = this.props;
    if (defaultStyle) return {};
    return {
      control: (base, state) => ({
        ...base,
        width: width || 300,
      }),
    };
  };

  render() {
    const { onChange } = this.props;
    return (
      <AsyncSelect
        placeholder={"Select GB Residue"}
        simpleValue={true}
        autoload={true}
        id="testname_id"
        loadOptions={this.fetchData}
        isClearable
        onChange={onChange}
      />
    );
  }
}
